import { computed } from "vue";

export function useAdvertiserMetadata({
  advertiserName,
}: {
  advertiserName: string;
}) {
  const config = useRuntimeConfig();

  const assetsUrl = config.public.ASSETS_URL;

  const advertiserMetadata = computed(() => {
    return {
      logo: `${assetsUrl}/assets/${advertiserName}/landing/logo.png`,
      smallLogo: `${assetsUrl}/assets/${advertiserName}/landing/logo-sm.svg`,
      cardImage: `${assetsUrl}/assets/${advertiserName}/landing/logo-card.png`,
    };
  });

  return {
    advertiserMetadata,
  };
}
